import { render, staticRenderFns } from "./AddToken.vue?vue&type=template&id=6da158a0&scoped=true&"
import script from "./AddToken.vue?vue&type=script&lang=js&"
export * from "./AddToken.vue?vue&type=script&lang=js&"
import style0 from "./AddToken.vue?vue&type=style&index=0&id=6da158a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da158a0",
  null
  
)

export default component.exports